var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merge-tag-wrapper" },
    [
      _c("el-button", {
        directives: [
          {
            name: "popover",
            rawName: "v-popover:input-popover",
            arg: "input-popover"
          }
        ],
        attrs: { type: "", icon: "el-icon-more" }
      }),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          ref: "input-popover",
          attrs: {
            placement: _vm.placement,
            width: "200",
            "popper-class": "el-dropdown-list-wrapper",
            trigger: "click"
          }
        },
        [
          [
            _c(
              "ul",
              { staticClass: "el-dropdown-menu el-dropdown-list" },
              [
                _vm.form_fields.length > 0
                  ? [
                      _c("span", { staticClass: "group-title" }, [
                        _vm._v(" Form Fields ")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.form_fields, function(field) {
                        return _c(
                          "li",
                          [
                            field.template === "name_field"
                              ? [
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "name-full",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(field.label))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "name-first",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("first")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "name-middle",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("middle")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "name-last",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("last")]
                                      )
                                    ]
                                  )
                                ]
                              : field.template === "image_upload"
                              ? [
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "image",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(field.label))]
                                      )
                                    ]
                                  )
                                ]
                              : field.template === "file_upload"
                              ? [
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "file",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(field.label))]
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "li",
                                    { staticClass: "el-dropdown-menu__item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.insertField(
                                                "field",
                                                field.name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(field.label) + " ")]
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.smart_tags, function(smarttag) {
                  return !_vm.calculate
                    ? _c("li", [
                        _c("span", { staticClass: "group-title" }, [
                          _vm._v(_vm._s(smarttag.title))
                        ]),
                        _vm._v(" "),
                        smarttag.tags
                          ? _c(
                              "ul",
                              _vm._l(smarttag.tags, function(tag, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass: "el-dropdown-menu__item",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.insertField(index)
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(tag) + " ")]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }